/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';

import '../styles/globals.scss';

import ReactGA from 'react-ga';
import { analyticsKey } from '../config';

ReactGA.initialize(analyticsKey);

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

MyApp.propTypes = {
  Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  pageProps: PropTypes.object,
};

export default MyApp;
